export const ROUTES = {
  root: '/',
  login: '/login',
  forgotPassword: '/forgot-password',
  resetPassword: (token: string = ':token') => `/reset-password/${token}`,
  profile: '/profile',
  dashboard: '/dashboard',
  users: '/users',
  viewUser: (id: string = ':id') => `/users/${id}`,
  bookings: '/bookings',
  viewBooking: (id: number | string) => `/bookings/${id}`,
  feedback: '/feedback',
  viewFeedback: (id: number | string) => `/feedback/${id}`,
  notifications: '/notifications',
  monetization: '/monetization',
  aiUsage: '/ai-usage',
  lookups: '/lookups',
  viewLookupCategory: (id: string = ':id') => `/lookups/${id}`,
  settings: '/settings',
} as const
